<template>
  <div id="app">
    <section class="hero is-link">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">
            One Way Streaming
          </h1>
          <h2 class="subtitle">
            Chunks of json
          </h2>
        </div>
      </div>
    </section>
    <div class="tabs mt-4 is-centered is-boxed is-medium">
      <ul>
        <li
          :class="{ 'is-active': selected === 'XJsonStream'}"
          @click="() => onChange('XJsonStream')"
        >
          <a>
            <span>X JSON Stream</span>
          </a>
        </li>
        <li
          :class="{ 'is-active': selected === 'EventSource'}"
          @click="() => onChange('EventSource')"
        >
          <a>
            <span>Event Source</span>
          </a>
        </li>
      </ul>
    </div>
    <component :is="selected"/>
  </div>
</template>

<script>
import 'bulma/css/bulma.min.css'
import XJsonStream from './components/XJSONStream'
import EventSource from "./components/EventSource"

export default {
  name: 'App',
  data() {
    return {
      selected: 'XJsonStream',
    }
  },
  components: {
    XJsonStream,
    EventSource,
  },
  methods: {
    onChange(tab) {
      this.selected = tab
    }
  },
}
</script>
